import { Workbook } from 'exceljs';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import {
  excelHeaders,
  excelMonthlyHeaders
} from '../routes/settings/MyBrokerCommissions/utils';

export const useGenerateExcel = () => {
  const { t } = useTranslation();

  const formattedContractCommissionExcel = (data, origin) => {
    const global = origin === 'global';
    let totalBf = 0;
    data.commission.content.map((item) => {
      totalBf += !global ? item.broker_fee : Number(item.brokerFee);
      if (global) {
        // eslint-disable-next-line no-param-reassign
        data.commission.total_pwf += Number(item.pwf);
        // eslint-disable-next-line no-param-reassign
        data.commission.amount += Number(item.commissions);
      }
      return true;
    });
    const total = {
      number: 'TOTAL',
      type: '',
      effective_date: '',
      last_name: '',
      first_name: '',
      fraction_type: '',
      ...(global ? { user: '' } : {}),
      termination_date: '',
      address: '',
      status: '',
      broker_fee: totalBf,
      commission_fee: '',
      contribution_adjustment: '',
      paperwork_fee: data.commission.total_pwf,
      ...(global
        ? {
            cotiPaye: '',
            cotiNonPaye: '',
            unpaid_fees: ''
          }
        : {}),
      remuneration: data.commission.amount,
      siret_number: ''
    };
    const debit = {
      ...total,
      number: 'TOTAL DÉBIT',
      broker_fee: '',
      paperwork_fee: '',
      remuneration: -data.commission.total_debt
    };
    const final_total = {
      ...total,
      number: 'TOTAL FINAL',
      broker_fee: '',
      paperwork_fee: '',
      remuneration: data.commission.amount - data.commission.total_debt
    };
    data.commission.content.push(total);
    if (!global && data.commission.total_debt) {
      data.commission.content.push(debit);
      data.commission.content.push(final_total);
    }
    data.commission.content.forEach((key) => {
      if (!global) {
        // eslint-disable-next-line no-param-reassign
        key.effective_date = key.effective_date
          ? moment(key.effective_date).format('DD-MM-YYYY')
          : '';
        // eslint-disable-next-line no-param-reassign
        key.termination_date = key.termination_date
          ? moment(key.termination_date).format('DD-MM-YYYY')
          : '';
        // eslint-disable-next-line no-param-reassign
        key.fraction_type = key.fraction_type
          ? t(`contracts.form.options.${key.fraction_type}`)
          : '';
      }
      // eslint-disable-next-line no-param-reassign
      key.status = t(`historic.${key.status}`);
    });
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Contrat');
    worksheet.mergeCells('A1', 'B2');
    const letters = ['A', 'B', 'C'];
    for (let j = 0; j < data.headers.length; j += 1) {
      const header = data.headers[j];
      const titleRow = worksheet.getCell(`A${j + 2}`);
      if (j === 0)
        titleRow.alignment = { vertical: 'middle', horizontal: 'center' };
      // eslint-disable-next-line no-underscore-dangle
      titleRow.width = titleRow._value.model.value?.length + 10;
      titleRow.font = {
        size: 13,
        bold: true
      };
      titleRow.value = header.title;
      for (let i = 0; i < header.values.length; i += 1) {
        const col = worksheet.getCell(`${letters[i + 1]}${j + 2}`);
        col.value = header.values[i];
        // eslint-disable-next-line no-underscore-dangle
        col.width = col._value.model.value?.length + 10;
      }
    }
    worksheet.addRow([]);
    let header;
    if (!global) {
      header = excelMonthlyHeaders.map(({ label }) => {
        return t(`contracts.list.column.${label}`);
      });
    } else {
      header = excelHeaders.map(({ label }) => {
        return t(`contracts.list.column.${label}`);
      });
    }

    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {
      // eslint-disable-next-line
      cell.width = cell._value.model.value?.length + 10;
      // eslint-disable-next-line
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '0085A3' },
        bgColor: { argb: '' }
      };
      // eslint-disable-next-line
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      };
    });

    let row;
    // eslint-disable-next-line no-underscore-dangle
    if (data._contracts) {
      // eslint-disable-next-line no-underscore-dangle
      data._contracts.forEach((d) => {
        row = Object.keys(d).map((_) => d[_]);
        worksheet.addRow(row);
      });
    }
    if (data.commission) {
      data.commission.content.forEach((c) => {
        row = Object.keys(c).map((i) => c[i]);
        worksheet.addRow(row);
      });
    }
    workbook.xlsx.writeBuffer().then((_data) => {
      const newBlob = new Blob([_data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = window.URL.createObjectURL(newBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${
        data.commission
          ? `Bordereau de commissions du ${moment(data.commission.date)
              .subtract(1, 'month')
              .format('MM-YYYY')}`
          : 'Contrats.xlsx'
      }`;
      a.click();
    });
  };
  return { formattedContractCommissionExcel };
};
